var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyCerts = function SvgEmptyCerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.083%",
    y1: "0%",
    x2: "50.602%",
    y2: "63.692%",
    id: "emptyCerts_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.032%",
    y1: "0%",
    x2: "51.875%",
    y2: "63.692%",
    id: "emptyCerts_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "32.844%",
    x2: "51.999%",
    y2: "54.698%",
    id: "emptyCerts_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.673%",
    y1: "-.184%",
    x2: "69.252%",
    y2: "92.029%",
    id: "emptyCerts_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50.003%",
    x2: "99.999%",
    y2: "50.003%",
    id: "emptyCerts_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.064%",
    y1: "0%",
    x2: "51.551%",
    y2: "63.692%",
    id: "emptyCerts_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "49.081%",
    x2: "51.999%",
    y2: "50.252%",
    id: "emptyCerts_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "48.362%",
    x2: "51.999%",
    y2: "50.449%",
    id: "emptyCerts_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.267%",
    y1: "13.299%",
    x2: "82.441%",
    y2: "86.64%",
    id: "emptyCerts_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.12%",
    y1: "0%",
    x2: "51.847%",
    y2: "63.692%",
    id: "emptyCerts_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "14.651%",
    x2: "51.999%",
    y2: "59.68%",
    id: "emptyCerts_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.725%",
    y1: "0%",
    x2: "50.401%",
    y2: "63.692%",
    id: "emptyCerts_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.211 1.63.657 2.526a.842.842 0 0 0 1.034.617.875.875 0 0 0 .597-1.068l-.656-2.526a.859.859 0 0 0-.597-.62.826.826 0 0 0-.818.226.891.891 0 0 0-.217.845Z",
    fill: "url(#emptyCerts_svg__a)",
    transform: "rotate(11 1.425 15.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.42 1.488 4.323 4.464a.826.826 0 0 0 1.184-.01.892.892 0 0 0 .01-1.223L2.613.255A.826.826 0 0 0 1.798.03a.858.858 0 0 0-.597.616c-.078.3.005.622.219.842Z",
    fill: "url(#emptyCerts_svg__b)",
    transform: "rotate(11 1.425 15.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.626 10.145 2.447.677a.842.842 0 0 0 1.03-.617.875.875 0 0 0-.594-1.067l-2.446-.677a.842.842 0 0 0-1.034.616.875.875 0 0 0 .597 1.068Z",
    fill: "url(#emptyCerts_svg__c)",
    transform: "rotate(11 1.425 15.867)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.03 9.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.077 1.21c0-.321.124-.629.347-.855C4.644.127 4.946 0 5.26 0h26.672L45.47 15.367v19.315s.042 15.954-4.384 23.571a1.17 1.17 0 0 1-.996.562c-4.526.004-31.396.004-38.908.004-.414 0-.798-.223-1.012-.588a1.233 1.233 0 0 1-.03-1.19c3.67-8.159 3.938-22.359 3.938-22.359V1.211Z",
    fill: "url(#emptyCerts_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.469 34.682s.042 15.954-4.384 23.571a1.17 1.17 0 0 1-.996.562c-4.526.004-31.396.004-38.908.004-.414 0-.798-.223-1.012-.588a1.233 1.233 0 0 1-.03-1.19l.046-.106c14.563.7 35.71-1.91 38.495-3.027 2.976-1.192 6.73-12.636 6.788-19.074v-.152Z",
    fill: "url(#emptyCerts_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.469 15.367c-3.59-1.452-7.392-1.493-11.293-.875-.362.058-.73-.06-.996-.319a1.222 1.222 0 0 1-.36-1.002c.429-4.473-.003-8.849-.888-13.171 5.722 4.348 10.24 9.467 13.537 15.367Z",
    fill: "url(#emptyCerts_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99 24.605h15.5c.652 0 1.182-.542 1.182-1.21 0-.669-.53-1.211-1.182-1.211H9.99c-.653 0-1.182.542-1.182 1.21 0 .669.53 1.211 1.182 1.211Z",
    fill: "url(#emptyCerts_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99 30.659h11.014c.653 0 1.183-.543 1.183-1.21 0-.67-.53-1.212-1.183-1.212H9.99c-.653 0-1.182.543-1.182 1.211s.53 1.21 1.182 1.21ZM9.99 36.713h11.014c.653 0 1.183-.543 1.183-1.211s-.53-1.21-1.183-1.21H9.99c-.653 0-1.182.542-1.182 1.21 0 .668.53 1.21 1.182 1.21ZM9.99 42.766h11.014c.653 0 1.183-.542 1.183-1.21 0-.669-.53-1.211-1.183-1.211H9.99c-.653 0-1.182.542-1.182 1.21 0 .669.53 1.211 1.182 1.211Z",
    fill: "url(#emptyCerts_svg__h)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#emptyCerts_svg__i)",
    cx: 45.231,
    cy: 36.864,
    rx: 17.739,
    ry: 18.161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.659 34.078c1.52-5.81 7.355-9.299 13.03-7.742 5.674 1.557 9.046 7.537 7.526 13.347-1.52 5.809-7.362 9.26-13.036 7.705a1.18 1.18 0 0 0-1.449.856c-.169.645.206 1.31.837 1.483C49.5 51.63 56.64 47.41 58.499 40.31c1.859-7.1-2.264-14.408-9.199-16.312-6.934-1.902-14.067 2.355-15.925 9.455-.169.645.206 1.31.836 1.483a1.18 1.18 0 0 0 1.448-.857Z",
    fill: "url(#emptyCerts_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.854 29.604 1.493 4.596c.206.635.875.977 1.495.767l4.489-1.528c.618-.21.954-.897.749-1.532a1.178 1.178 0 0 0-1.495-.766l-3.367 1.146-1.12-3.447a1.177 1.177 0 0 0-1.495-.767c-.62.212-.956.897-.749 1.531Z",
    fill: "url(#emptyCerts_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.231 30.81v7.919l-3.726 3.269a1.23 1.23 0 0 0-.128 1.707 1.164 1.164 0 0 0 1.667.132l4.14-3.633c.26-.23.412-.566.412-.918V30.81c0-.668-.53-1.21-1.182-1.21-.653 0-1.183.542-1.183 1.21Z",
    fill: "url(#emptyCerts_svg__l)"
  })))));
};
export default SvgEmptyCerts;